import React from "react";
import "./search.css";
import {FaSearch} from "react-icons/fa"

function Search (item) {
    return(
        <div className="container mainempheader">
            <div className="row empheader">
                <div className="col-8 empheadertitle">{item.title}</div>
                <div className="col-4 empsearchallowable">
                <span className="searchicon" ><FaSearch /></span>
                <form action="">
                <input type="search" className='searchsty' placeholder="Search" />
              </form>
                </div>
            </div>
        </div>
    )
};

export default Search;